/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestUpsertShippingSourceInformationRequest
 */
export interface RequestUpsertShippingSourceInformationRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestUpsertShippingSourceInformationRequest
     */
    addressLine1: string;
    /**
     * 
     * @type {string}
     * @memberof RequestUpsertShippingSourceInformationRequest
     */
    city: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpsertShippingSourceInformationRequest
     */
    countryId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestUpsertShippingSourceInformationRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestUpsertShippingSourceInformationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RequestUpsertShippingSourceInformationRequest
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof RequestUpsertShippingSourceInformationRequest
     */
    postalCode: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpsertShippingSourceInformationRequest
     */
    prefectureId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestUpsertShippingSourceInformationRequest
     */
    tenantId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestUpsertShippingSourceInformationRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestUpsertShippingSourceInformationRequest interface.
 */
export function instanceOfRequestUpsertShippingSourceInformationRequest(value: object): value is RequestUpsertShippingSourceInformationRequest {
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('countryId' in value) || value['countryId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('postalCode' in value) || value['postalCode'] === undefined) return false;
    if (!('prefectureId' in value) || value['prefectureId'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestUpsertShippingSourceInformationRequestFromJSON(json: any): RequestUpsertShippingSourceInformationRequest {
    return RequestUpsertShippingSourceInformationRequestFromJSONTyped(json, false);
}

export function RequestUpsertShippingSourceInformationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestUpsertShippingSourceInformationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'addressLine1': json['address_line1'],
        'city': json['city'],
        'countryId': json['country_id'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'phoneNumber': json['phone_number'],
        'postalCode': json['postal_code'],
        'prefectureId': json['prefecture_id'],
        'tenantId': json['tenant_id'],
        'userId': json['user_id'],
    };
}

export function RequestUpsertShippingSourceInformationRequestToJSON(json: any): RequestUpsertShippingSourceInformationRequest {
    return RequestUpsertShippingSourceInformationRequestToJSONTyped(json, false);
}

export function RequestUpsertShippingSourceInformationRequestToJSONTyped(value?: RequestUpsertShippingSourceInformationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address_line1': value['addressLine1'],
        'city': value['city'],
        'country_id': value['countryId'],
        'id': value['id'],
        'name': value['name'],
        'phone_number': value['phoneNumber'],
        'postal_code': value['postalCode'],
        'prefecture_id': value['prefectureId'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

